import { Injectable } from '@angular/core'
import { of } from 'rxjs'
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject'
import { CommonService } from '../../shared/services/common.service'

@Injectable({
  providedIn: 'root',
})
export class LandingPagesService {
  preLoadImages = new BehaviorSubject(false)
  floatOrderTrackingValues = new BehaviorSubject({
    customerNumber: null,
    purchaseOrderNumber: null,
    orderReferenceNumber: null,
  })
  constructor(public commonService: CommonService) {}

  fetchTopBanner() {
    const urlParam = [
      'users',
      'anonymous',
      'boilerPlateComponent',
      'BoilerPlateGuestUser',
    ]
    const url = this.commonService.constructUrl(urlParam)
    const apiParams = {
      fields: 'FULL',
    }
    return this.commonService.getData(url, apiParams)
  }

  fetchCarouselBannerDetails() {
    const urlParam = ['users', 'current', 'boilerPlateComponent']
    const url = this.commonService.constructUrl(urlParam)
    return this.commonService.getData(url)
  }
}
